import React from "react";
import PropTypes from "prop-types";
import assetify from "@quintype/framework/assetify";
import groupImage from "../../../../assets/images/nl-images/newsletter-CTA-on-homepage.png";
import { Button } from "../../atoms/button";
import "./subscribe-to-newsletters.m.css";

const defaultSummary = "We deliver weekly newsletters. Customised and curated for you. Check it out.";
const defaulttitle = "No spam! Newslaundry newsletters, tailored to your interests.";

export const SubscribeToNewsletters = ({ collection = {} }) => {
  return (
    <div styleName="row-container">
      <div styleName="subscribe-wrapper" className="full-width-with-padding">
        <div styleName="group-img">
          <img styleName="newsletter-image" src={assetify(groupImage)} alt="newlaundry logo" />
        </div>
        <div styleName="content-wrapper">
          <div styleName="collection-title">{collection.name || defaulttitle}</div>
          <div styleName="collection-summary">{collection.summary || defaultSummary}</div>
          <div styleName="btn-input">
            <div styleName="subscribe-button">
              <Button href={"/newsletter-signup"}>Sign Up</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SubscribeToNewsletters.propTypes = {
  collection: PropTypes.object
};
